import {createContext, RefObject, useContext, useEffect, useState} from "react";

export const FullScreenNodeContext = createContext<RefObject<HTMLElement>>(null as any);

export const useIsFullScreen = () => {
  const [on, setOn] = useState(() => Boolean(document.fullscreenElement));
  useEffect(() => {
    const cb = () => setOn(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", cb);
    return () => document.removeEventListener("fullscreenchange", cb);
  }, []);
  const fsContext = useContext(FullScreenNodeContext);
  const handleFullScreen = () => {
    if (on) {
      document.exitFullscreen?.();
    } else {
      fsContext.current?.requestFullscreen?.();
    }
  };
  return [on, handleFullScreen] as const;
};
